import Base from './base'
import { Person, PersonCustomFields } from '../types/person'

type CreatePersonPayload = Partial<Person> & {
  account_id?: number
  custom_fields?: PersonCustomFields
}

type AddPersonToAccountPayload = {
  account_id: number
}

export default class PublicPeople extends Base {
  async get(searchParams: Record<string, unknown>) {
    const result = await this.api.get('people', { params: searchParams })

    return result?.data
  }

  async create(payload: CreatePersonPayload) {
    const result = await this.api.post('people', payload)
    return result?.data
  }

  addPersonToAccount(personId: number, payload: AddPersonToAccountPayload) {
    return this.api.put(`people/${personId}`, payload)
  }

  updatePauseWindow(payload: Record<string, unknown>) {
    return this.api.post(`person_pause_windows`, payload)
  }
  getPauseWindow(personId: number) {
    return this.api.get(`person_pause_windows?person_id=${personId}`)
  }
  removePauseWindow(personId: number) {
    return this.api.delete(`person_pause_windows/${personId}`)
  }

  getHotLeadData(personId: number) {
    return this.api.get(`hot_leads?person_id=${personId}&sort_by=expiration_at`)
  }
}
